// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"246":"landing","757":"game","884":"explain","940":"score"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".js";
};